// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#widget-container .send-box {
  display: flex;
  width: 60px;
  height: 60px;
  padding: 19px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}
#widget-container .ack-button {
  padding: 12px 24px;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
  width: 324px;
}

#widget-container .primary {
  background-color: #2251ff;
  color: white;
  border: none;
}

#widget-container .secondary {
  background-color: #fff;
  color: #2251ff;
  border: 1px solid var(--color-border-primary, #2251ff);
}
`, "",{"version":3,"sources":["webpack://./src/components/buttons/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,sDAAsD;AACxD","sourcesContent":["#widget-container .send-box {\n  display: flex;\n  width: 60px;\n  height: 60px;\n  padding: 19px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n}\n#widget-container .ack-button {\n  padding: 12px 24px;\n  font-size: 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  width: 324px;\n}\n\n#widget-container .primary {\n  background-color: #2251ff;\n  color: white;\n  border: none;\n}\n\n#widget-container .secondary {\n  background-color: #fff;\n  color: #2251ff;\n  border: 1px solid var(--color-border-primary, #2251ff);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
